import { Box } from '@mui/material';
import {
  getCustomerName,
  getFormattedTransactionDate,
} from 'pages/payments/transactions/transactions.utils';
import { useTranslation } from 'react-i18next';
import DetailsSingleSection from '../detail-single-section/detail-single-section.component';
import DetailsSection from '../details-section.component';
import { getTransactionIdData } from './payment-overview.utils';
import TypeCell from 'pages/payments/transactions/transactions-data-grid/type-cell/type-cell.component';
import CustomerLink from 'components/customer/customer-name/customer-link.component';

const PaymentOverview = ({ transaction }) => {
  const { t } = useTranslation();
  const {
    createdDate,
    customer,
    transactionId,
    orderId,
    type,
    giftCardId,
    scanToPayTxId,
    userId,
  } = transaction ?? {};

  const details = [
    {
      title: t('drawer.transactionDrawer.createdDate'),
      detail: getFormattedTransactionDate(createdDate),
    },
    {
      title: t('drawer.transactionDrawer.customer'),
      detail: (
        <CustomerLink
          customerName={getCustomerName(customer)}
          customerId={userId !== 'GUEST' ? userId : null}
        />
      ),
    },
    {
      ...getTransactionIdData(type, { orderId, giftCardId, scanToPayTxId }),
    },
    {
      title: t('drawer.transactionDrawer.transactionId'),
      detail: transactionId,
    },
    {
      title: t('TransactionsDataGrid.column.type.label'),
      detail: <TypeCell params={{ value: type }} />,
    },
  ];

  return (
    <Box>
      <DetailsSection>
        {details.map(data => (
          <DetailsSingleSection {...data} key={data.title} />
        ))}
      </DetailsSection>
    </Box>
  );
};

export default PaymentOverview;
